import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getUserRole, isAuthenticated } from "../auth/roles";

const ProtectedRoute = ({ roles }) => {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }
  if (roles && !roles.includes(getUserRole())) {
    return <Navigate to="/home" replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
